import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const [form, setForm] = useState({ name: "", order: 0 });
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/categories", { params: { all: true } }).then((r) => setCats(r.data));
  useEffect(() => { load(); }, []);
  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(`/categories/${editing.id}`, { ...editing, name: form.name, order: Number(form.order) });
      else await api.post("/categories", { name: form.name, order: Number(form.order) });
      toast.success("Tersimpan"); setForm({ name: "", order: 0 }); setEditing(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); }
  };
  const editCat = (c) => { setEditing(c); setForm({ name: c.name, order: c.order }); };
  const arc = async (id) => { await api.delete(`/categories/${id}`); load(); };
  return (
    <div>
      <h1 className="display text-4xl md:text-6xl mb-6">CATEGORIES</h1>
      <div className="grid md:grid-cols-[1fr,320px] gap-6">
        <div className="border border-[color:var(--border)]">
          <table className="w-full text-sm">
            <thead className="text-[10px] tracking-widest text-neutral-500"><tr className="border-b border-[color:var(--border)]">
              <th className="p-3 text-left">NAME</th><th className="p-3 text-left">SLUG</th><th className="p-3 text-left">ORDER</th><th></th>
            </tr></thead>
            <tbody>{cats.map((c) => (
              <tr key={c.id} data-testid={`cat-row-${c.slug}`} className="border-b border-[color:var(--border)]">
                <td className="p-3">{c.name}{c.archived && <span className="ml-2 status-badge">ARCHIVED</span>}</td>
                <td className="p-3 mono">{c.slug}</td><td className="p-3">{c.order}</td>
                <td className="p-3 space-x-2"><button onClick={() => editCat(c)} className="underline">Edit</button><button onClick={() => arc(c.id)} className="underline text-[color:var(--accent)]">Archive</button></td>
              </tr>))}</tbody>
          </table>
        </div>
        <form onSubmit={save} className="border border-[color:var(--border)] p-4 space-y-3 h-fit">
          <div className="text-[10px] tracking-widest text-neutral-500">{editing ? "EDIT" : "NEW"} CATEGORY</div>
          <input data-testid="cat-name" required placeholder="Nama" className="w-full bg-transparent border border-[color:var(--border)] p-2 text-sm" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          <input type="number" placeholder="Order" className="w-full bg-transparent border border-[color:var(--border)] p-2 text-sm" value={form.order} onChange={(e) => setForm({ ...form, order: e.target.value })} />
          <button data-testid="cat-save" className="w-full bg-white text-black py-2 text-xs tracking-widest">{editing ? "UPDATE" : "TAMBAH"}</button>
          {editing && <button type="button" onClick={() => { setEditing(null); setForm({ name: "", order: 0 }); }} className="w-full border border-white py-2 text-xs">BATAL</button>}
        </form>
      </div>
    </div>
  );
}
